"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberSliderSelect = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

require("./NumberSliderSelect.css");

var _UseEffectPartialDeps = _interopRequireDefault(require("../utils/UseEffectPartialDeps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const cosmos = {};

const NumberSliderSelect = _ref => {
  let {
    value,
    setValue,
    flip,
    thin,
    min = 1,
    max = 10,
    shadow,
    size = 40,
    color = 'white',
    numberBgColor = '#663399FF',
    selectorColor = '#1E90FFFF',
    pointerColor = '#6c9fff',
    pointerShadowColor = '#33333390',
    top = -16
  } = _ref;
  const [id] = (0, _react.useState)("id-".concat(Math.random()));
  const [rendered, setRendered] = (0, _react.useState)(false);
  const [showInput, setShowInput] = (0, _react.useState)(false);
  const [hidden, setHidden] = (0, _react.useState)(false);
  const [timeout1, setTimeout1] = (0, _react.useState)(0);
  const [timeout2, setTimeout2] = (0, _react.useState)(0);
  const options = [...Array(Math.max(max - min + 1, 1)).keys()].map(v => v + min);
  let cosmoState = cosmos[id];
  (0, _react.useLayoutEffect)(() => {
    cosmoState = cosmos[id] = {
      refs: []
    };
    setRendered(true);
  }, []);
  (0, _UseEffectPartialDeps.default)(() => {
    clearTimeout(timeout1);
    if (showInput) setHidden(false);else setTimeout1(setTimeout(() => setHidden(true), 320));
  }, [showInput]);
  (0, _UseEffectPartialDeps.default)(() => {
    if (!rendered) return;
    const ref = cosmoState.refs[value + 2 - min];
    if (!ref) return;
    ref.scrollIntoView();
  }, [rendered]);
  if (!cosmoState) return /*#__PURE__*/_react.default.createElement("div", null);

  const getExactValue = () => cosmoState.scrollRef.scrollLeft / size + min;

  if (max - min === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const optionStyle = {
    width: "".concat(size, "px"),
    height: "".concat(size - 1, "px"),
    fontSize: "".concat(size * .6, "px"),
    borderRadius: "".concat(size, "px"),
    paddingBottom: '1px'
  };

  const renderFade = (side, direction) => /*#__PURE__*/_react.default.createElement("div", {
    className: "fade ".concat(side),
    style: {
      width: "".concat(size * .8, "px"),
      backgroundImage: "linear-gradient(to ".concat(direction, ", ").concat(selectorColor, ", ").concat(selectorColor, " , #00000000)")
    }
  });

  const pointerContainerStyle = flip ? {
    bottom: "-".concat(size * .4, "px"),
    transform: 'rotate(180deg)'
  } : {
    top: "-".concat(size / 2, "px")
  };

  const renderModal = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "inputModal ".concat(showInput ? '' : 'hidden', " ").concat(shadow ? 'shadow' : ''),
    style: {
      backgroundColor: selectorColor,
      top: "".concat(top + (thin ? 8 : 0), "px")
    },
    onTouchStart: () => {
      clearTimeout(timeout2);
      setShowInput(true);
    },
    onTouchEnd: () => {
      clearTimeout(timeout2);
      setTimeout2(setTimeout(() => setShowInput(false), 800));
    }
  }, renderFade('left', 'right'), renderFade('right', 'left'), /*#__PURE__*/_react.default.createElement("div", {
    className: "pointerContainer",
    style: pointerContainerStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pointerShadow",
    style: {
      backgroundColor: pointerShadowColor,
      width: "".concat(size / 2, "px"),
      height: "".concat(size * 0.8, "px"),
      marginTop: "".concat(size / 7, "px")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pointerContainer",
    style: pointerContainerStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pointer",
    style: {
      backgroundColor: pointerColor,
      width: "".concat(size / 2, "px"),
      height: "".concat(size * 0.8, "px")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "scrollSelector ".concat(thin ? 'thin' : ''),
    ref: node => cosmoState.scrollRef = node,
    style: {
      width: "".concat(size * 3, "px")
    },
    onScroll: () => {
      const centerNumber = Math.round(getExactValue());
      if (value !== centerNumber) setValue(centerNumber);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "options",
    style: {
      width: "".concat((options.length + 2) * size, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "option",
    style: optionStyle,
    ref: node => cosmoState.refs[0] = node
  }), options.map((n, i) => /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, optionStyle), {}, {
      backgroundColor: value === n ? numberBgColor : ''
    }),
    key: n,
    ref: node => cosmoState.refs[i + 1] = node,
    className: 'option'
  }, n)), /*#__PURE__*/_react.default.createElement("div", {
    className: "option",
    style: optionStyle,
    ref: node => cosmoState.refs[options.length + 1] = node
  }))));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "NumberSliderSelectWrapper  ".concat(hidden ? 'hidden' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "NumberSliderSelect",
    style: _objectSpread(_objectSpread({}, optionStyle), {}, {
      color,
      backgroundColor: numberBgColor
    })
  }, value, renderModal()));
};

exports.NumberSliderSelect = NumberSliderSelect;